export enum SELLER_STATUS {
  NOT_VERIFY = "not_verify",
  SUBMITTED = "submitted",
  VERIFYING = "verifying",
  VERIFIED = "verified",
  REJECTED = "rejected",
}

export enum CREDIT_STATUS {
  NOT_VERIFY = "not_verify",
  SUBMITTED = "submitted",
  VERIFYING = "verifying",
  VERIFIED = "verified",
  REJECTED = "rejected",
}
